module.exports = __webpack_public_path__ + "fonts/Gilroy-ThinItalic.0af99171.eot";